export default function Home() {
  return (
    <div className="bg-[#F9F8F6] min-h-screen">
      {/* Top Introduction Section */}
      <section className="pt-20 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-4 mb-16">
            <img 
              src="https://public.readdy.ai/ai/img_res/0e651fc5-2f2e-48cd-afbb-7b76c6e1731e.png" 
              alt="Ression Logo" 
              className="h-12 w-auto"
            />
            <div className="border-l border-[#E5E7EB] pl-4">
              <h1 className="text-sm tracking-wider text-[#111827] font-light" style={{ fontFamily: "'Inter', sans-serif" }}>
                RealEstateInvest.uk
              </h1>
            </div>
          </div>
          
          <h2 className="text-5xl md:text-6xl leading-tight mb-8 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
            UK real estate opportunities and investment insights, delivered directly.
          </h2>
          
          <p className="text-lg leading-relaxed text-[#6B7280] max-w-2xl" style={{ fontFamily: "'Inter', sans-serif" }}>
            Ression provides structured visibility into selected UK property opportunities. Our newsletter shares new listings, regional market observations, and investment briefings.
          </p>
        </div>
      </section>

      {/* Newsletter Sign-up Section (Primary) */}
      <section className="py-24 px-6 bg-[#111827]">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-4xl md:text-5xl mb-6 text-[#F9F8F6]" style={{ fontFamily: "'Crimson Pro', serif" }}>
            Join the Ression investor newsletter
          </h3>
          
          <p className="text-lg mb-12 text-[#E5E7EB]" style={{ fontFamily: "'Inter', sans-serif" }}>
            Receive periodic updates featuring UK property opportunities, research, and investment commentary.
          </p>
          
          <form 
            id="newsletter-primary"
            data-readdy-form
            action="https://readdy.ai/api/form/d6g9fvn1jbcgr9kd7chg"
            method="POST"
            className="space-y-6"
          >
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm mb-2 text-[#E5E7EB]" style={{ fontFamily: "'Inter', sans-serif" }}>
                  First name
                </label>
                <input 
                  type="text"
                  name="first_name"
                  required
                  className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E5E7EB] text-[#111827] focus:outline-none focus:border-[#7A8F85]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
              </div>
              
              <div>
                <label className="block text-sm mb-2 text-[#E5E7EB]" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Email address
                </label>
                <input 
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E5E7EB] text-[#111827] focus:outline-none focus:border-[#7A8F85]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
              </div>
            </div>
            
            <div>
              <label className="block text-sm mb-2 text-[#E5E7EB]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Investor profile
              </label>
              <select 
                name="investor_profile"
                required
                className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E5E7EB] text-[#111827] focus:outline-none focus:border-[#7A8F85]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                <option value="">Select profile</option>
                <option value="Private investor">Private investor</option>
                <option value="Company">Company</option>
                <option value="Adviser">Adviser</option>
              </select>
            </div>
            
            <button 
              type="submit"
              className="w-full md:w-auto px-12 py-3 bg-[#7A8F85] text-[#F9F8F6] text-sm tracking-wider whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Subscribe
            </button>
            
            <p className="text-xs text-[#6B7280] mt-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Capital at risk. Information provided is for general informational purposes only.
            </p>
          </form>
        </div>
      </section>

      {/* Subscriber Investment Summaries Section */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-4xl mb-6 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
            Subscriber investment summaries
          </h3>

          <p className="text-base text-[#6B7280] mb-16 max-w-2xl" style={{ fontFamily: "'Inter', sans-serif" }}>
            The following examples reflect the types of UK property opportunities outlined in our investor communications.
          </p>

          <div className="space-y-12">
            {/* Manchester */}
            <article className="pb-12 border-b border-[#E5E7EB]">
              <h4 className="text-2xl mb-3 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
                Manchester – Mixed-use development
              </h4>
              <p className="text-base leading-relaxed mb-5 text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
                City centre scheme combining residential and commercial space, supported by established transport links and ongoing regional infrastructure investment.
              </p>
              <div className="text-sm text-[#111827] space-y-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                <div><strong>Target return:</strong> 8.5% p.a.*</div>
                <div><strong>Term:</strong> 24 months</div>
                <div><strong>Minimum investment:</strong> £25,000</div>
                <div><strong>Structure:</strong> Asset-backed*</div>
              </div>
            </article>

            {/* Birmingham */}
            <article className="pb-12 border-b border-[#E5E7EB]">
              <h4 className="text-2xl mb-3 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
                Birmingham – Residential conversion
              </h4>
              <p className="text-base leading-relaxed mb-5 text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Former commercial building converted into residential units within Birmingham's expanding professional quarter, with documented planning consent in place.
              </p>
              <div className="text-sm text-[#111827] space-y-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                <div><strong>Target return:</strong> 9.2% p.a.*</div>
                <div><strong>Term:</strong> 18 months</div>
                <div><strong>Minimum investment:</strong> £50,000</div>
                <div><strong>Structure:</strong> Asset-backed*</div>
              </div>
            </article>

            {/* Leeds */}
            <article className="pb-12 border-b border-[#E5E7EB]">
              <h4 className="text-2xl mb-3 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
                Leeds – Build-to-rent portfolio
              </h4>
              <p className="text-base leading-relaxed mb-5 text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Portfolio of purpose-built rental properties in Leeds' northern districts, structured around existing tenancy agreements and documented rental yields.
              </p>
              <div className="text-sm text-[#111827] space-y-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                <div><strong>Target return:</strong> 7.8% p.a.*</div>
                <div><strong>Term:</strong> 36 months</div>
                <div><strong>Minimum investment:</strong> £100,000</div>
                <div><strong>Structure:</strong> Asset-backed*</div>
              </div>
            </article>

            {/* Liverpool */}
            <article className="pb-12 border-b border-[#E5E7EB]">
              <h4 className="text-2xl mb-3 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
                Liverpool – Waterfront regeneration
              </h4>
              <p className="text-base leading-relaxed mb-5 text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Phased waterfront regeneration with residential and leisure components, aligned with Liverpool's documented regeneration framework and public sector commitments.
              </p>
              <div className="text-sm text-[#111827] space-y-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                <div><strong>Target return:</strong> 10.5% p.a.*</div>
                <div><strong>Term:</strong> 30 months</div>
                <div><strong>Minimum investment:</strong> £75,000</div>
                <div><strong>Structure:</strong> Asset-backed*</div>
              </div>
            </article>

            {/* Nottingham */}
            <article className="pb-12 border-b border-[#E5E7EB]">
              <h4 className="text-2xl mb-3 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
                Nottingham – Student accommodation
              </h4>
              <p className="text-base leading-relaxed mb-5 text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Purpose-built student accommodation near Nottingham's university campuses, underpinned by institutional nomination agreements and documented occupancy rates.
              </p>
              <div className="text-sm text-[#111827] space-y-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                <div><strong>Target return:</strong> 8.0% p.a.*</div>
                <div><strong>Term:</strong> 24 months</div>
                <div><strong>Minimum investment:</strong> £30,000</div>
                <div><strong>Structure:</strong> Asset-backed*</div>
              </div>
            </article>
          </div>

          <p className="text-sm text-[#6B7280] mt-12" style={{ fontFamily: "'Inter', sans-serif" }}>
            Full summaries are shared exclusively via the Ression newsletter.
          </p>
        </div>
      </section>

      {/* Market Perspective Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-4xl mb-8 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
            Market perspective
          </h3>
          
          <div className="space-y-6 text-base leading-relaxed text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
            <p>
              Ression focuses on presenting selected UK real estate opportunities within a structured and transparent framework. Our approach prioritises clarity, documentation, and disciplined evaluation.
            </p>
            <p>
              Each opportunity featured through our platform undergoes assessment against defined criteria including legal structure, asset backing, documentation quality, and alignment with regional market conditions.
            </p>
            <p>
              We maintain a selective approach, presenting opportunities that meet our internal standards for transparency and structural integrity. Our newsletter provides regular commentary on UK regional markets, regulatory developments, and investment considerations.
            </p>
          </div>
        </div>
      </section>

      {/* Secondary Newsletter Reminder Section */}
      <section className="py-24 px-6 border-t border-[#E5E7EB]">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-3xl mb-6 text-[#111827]" style={{ fontFamily: "'Crimson Pro', serif" }}>
            Stay informed
          </h3>
          
          <p className="text-base mb-12 text-[#6B7280]" style={{ fontFamily: "'Inter', sans-serif" }}>
            New opportunities and market commentary are shared exclusively through the Ression newsletter.
          </p>
          
          <form 
            id="newsletter-secondary"
            data-readdy-form
            action="https://readdy.ai/api/form/d6g9fvn1jbcgr9kd7chg"
            method="POST"
            className="space-y-6"
          >
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm mb-2 text-[#111827]" style={{ fontFamily: "'Inter', sans-serif" }}>
                  First name
                </label>
                <input 
                  type="text"
                  name="first_name"
                  required
                  className="w-full px-4 py-3 bg-white border border-[#E5E7EB] text-[#111827] focus:outline-none focus:border-[#7A8F85]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
              </div>
              
              <div>
                <label className="block text-sm mb-2 text-[#111827]" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Email address
                </label>
                <input 
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 bg-white border border-[#E5E7EB] text-[#111827] focus:outline-none focus:border-[#7A8F85]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
              </div>
            </div>
            
            <div>
              <label className="block text-sm mb-2 text-[#111827]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Investor profile
              </label>
              <select 
                name="investor_profile"
                required
                className="w-full px-4 py-3 bg-white border border-[#E5E7EB] text-[#111827] focus:outline-none focus:border-[#7A8F85]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                <option value="">Select profile</option>
                <option value="Private investor">Private investor</option>
                <option value="Company">Company</option>
                <option value="Adviser">Adviser</option>
              </select>
            </div>
            
            <button 
              type="submit"
              className="w-full md:w-auto px-12 py-3 bg-[#111827] text-[#F9F8F6] text-sm tracking-wider whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 px-6 bg-[#7A8F85]">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/0e651fc5-2f2e-48cd-afbb-7b76c6e1731e.png" 
              alt="Ression Logo" 
              className="h-10 w-auto"
            />
            <div className="border-l border-[#F9F8F6]/30 pl-4">
              <div className="text-sm text-[#F9F8F6]" style={{ fontFamily: "'Inter', sans-serif" }}>
                RealEstateInvest.uk
              </div>
            </div>
          </div>
          
          <p className="text-sm text-[#F9F8F6] mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>
            United Kingdom
          </p>
          
          <div className="pt-8 mt-8 border-t border-[#F9F8F6]/20">
            <p className="text-xs leading-relaxed text-[#F9F8F6]/80 max-w-3xl" style={{ fontFamily: "'Inter', sans-serif" }}>
              This website is for informational purposes only and does not constitute investment advice. Capital is at risk. Past performance is not indicative of future results. All investment opportunities are subject to availability and eligibility criteria.
            </p>
            <p className="text-xs text-[#F9F8F6]/60 mt-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              <a href="https://readdy.ai/?ref=logo" className="hover:text-[#F9F8F6]">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
